import React from "react";
import Founders from "@/components/sections/Founders";
import WhyChoose from "@/components/sections/WhyChoose";
import ServiceArea from "@/components/sections/ServiceArea";
import ContactSection from "@/components/sections/ContactSection";
import BigCTA from "@/components/sections/BigCTA";

export default function AboutPage() {
  return (
    <main data-testid="about-page" className="pt-36 md:pt-44">
      <section className="container-x pb-6">
        <div className="max-w-3xl">
          <h1 className="text-[36px] md:text-[56px] font-extrabold text-navy leading-[1.1]">About Velixa Health</h1>
          <p className="mt-5 text-ink/85 text-[18px] max-w-2xl">
            Velixa Health is a nurse-led home healthcare service founded by <span className="font-semibold">Saki &amp; Bibek</span>, both former nurses at Manipal Hospitals. We believe high-quality nursing shouldn't stop at the hospital gate — it should follow the patient home, where healing actually happens.
          </p>
        </div>
      </section>
      <Founders />
      <WhyChoose />
      <ServiceArea />
      <BigCTA />
      <ContactSection />
    </main>
  );
}
